module.exports = "https://bin.bnbstatic.com/_next/static/images/binance life 2-49d536cbd6ab8c070a7507a7ad575602.jpg";